import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default from 'react';
import BaseDivider from '@mui/material/Divider';
import c from 'classnames';

var _excluded = ["className", "color", "style"];
var Divider = function Divider(props) {
  var className = props.className,
    _props$color = props.color,
    color = _props$color === void 0 ? 'border-divider' : _props$color;
    props.style;
    var restProps = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/React__default.createElement(BaseDivider, _extends({
    className: c(color, className)
  }, restProps));
};
var Divider$1 = /*#__PURE__*/React__default.memo(Divider);

export { Divider$1 as default };
//# sourceMappingURL=Divider.js.map
